/*
 *   File : pms.js
 *   Author : https://evoqins.com
 *   Description : Portfolio management service page
 *   Integrations : NA
 *   Version : 1.0.0
*/

import React, { useEffect, useState } from 'react'

// Components
import { Footer } from '../../Component/Footer'
import { DetailPreviewCard, PortfolioCard } from '../../Component/Cards'
import { CustomTab, EmptyScreen, Loader } from '../../Component/Other';
import { SectionTitle } from '../../Component/Title';
import { APIService } from '../../Service';
import { Icon } from '../../Component/Icon';
import { _openOffcanvasModal } from '../../Helper/function';
import { OffcanvasDetailViewModal } from '../../Component/Modal';

const PMS_TAB = [
    {
        id: 1,
        label: "Overview"
    },
    {
        id: 2,
        label: "Investments"
    },
];

function PMS() {

    const show_values = localStorage.getItem(btoa("show_values_pms"));

    const [isDataLoading, setIsDataLoading] = useState(true);
    const [portfolioSummary, setShowPortfolioSummary] = useState({});
    const [portfolioTransactions, setShowPortfolioTransactions] = useState({});
    const [showValues, setShowValues] = useState(show_values ? show_values === "true" : true);
    const [tabIndex, setTabIndex] = useState(1);
    const [isCardView, setIsCardView] = useState(false);
    const [selectedOrder, setSelectedOrder] = useState({});



    useEffect(() => {
        // API call
        _getPortfolioOverview(); // main call
        _getPortfolioInvestments(); // second tab data - prefetching
    }, []);

    useEffect(() => {
        if (selectedOrder.fund_name && window.innerWidth < 768) {
            _openOffcanvasModal();
        }
    }, [selectedOrder]);


    //handle tab change
    const _handleTabChange = (id) => {
        setTabIndex(id);
    };

    const _handleToggleShowValues = () => {
        setShowValues(prev => {
            localStorage.setItem(btoa("show_values_pms"), !prev);
            return !prev
        });
    };

    const _handleChangeOrdersView = () => {
        setIsCardView(prev => !prev);
    };


    const _handleSelectOrderItem = (selected_order) => {
        if (selectedOrder?.fund_name !== selected_order.fund_name) {
            setSelectedOrder(selected_order);
        } else {
            // when click selected item again
            if (selectedOrder.fund_name && window.innerWidth < 768) {
                _openOffcanvasModal();
            }
        }
    };

    // *********** API ***************//
    // API - Get portfolio overview summary
    const _getPortfolioOverview = () => {
        let api_version = 2;
        let is_post = false;
        let url = 'portfolio/overview';

        APIService(is_post, url, null, null, api_version).then((response) => {
            if (response.status_code === 200) {
                setShowPortfolioSummary(response.data);
            }
            setIsDataLoading(false);
        });
    }

    // API - Get portfolio overview summary
    const _getPortfolioInvestments = () => {
        let api_version = 2;
        let is_post = false;
        let url = 'portfolio/transactions';

        APIService(is_post, url, null, null, api_version).then((response) => {
            if (response.status_code === 200) {
                setShowPortfolioTransactions(response.data?.transactions);
            }
        });
    }

    // *********** Inner Components ***************//
    const BreakDownDataCard = ({ breakdownData, title, type }) => {

        const text_class = "e-color-black e-font-14-res e-font-16 e-primary-font-inter e-font-weight-400 line-height-28px";

        return (
            <div className="e-bg-cultured padding-32px-all padding-12px-bottom padding-16px-all-res  e-border-radius-16 h-100">

                <div className="d-flex justify-content-between ">

                    <SectionTitle title={title}
                        fontFamily="e-primary-font-inter"
                        fontSiz="e-font-20"
                        className=" e-text-eerie-black mb-sm-4 mb-0" />

                    {
                        type === 2 &&
                        <span className=' e-text-eerie-black e-primary-font-inter e-font-18 e-font-14-res e-font-weight-600 line-height-24px'>
                            {breakdownData && breakdownData.length && breakdownData.reduce((acc, item) => acc + (item.percentage || 0), 0)}%
                        </span>
                    }

                </div>
                {
                    breakdownData.length === 0 ?
                        <div className="mt-5">
                            <EmptyScreen img={require("../../Assets/Images/EmptyScreen/no-data.webp")}
                                title="No data found"
                                type={2}
                                description="There is nothing to show right now." />
                        </div>
                        :
                        <div className={`d-flex flex-column ${type === 1 ? "row-gap-2" : "row-gap-sm-4 row-gap-2"} `}>
                            {
                                (breakdownData || []).map((item, id) => (
                                    type === 1 ?
                                        <>
                                            {
                                                id === 0 &&
                                                <div className="d-flex align-items-center justify-content-between py-2 padding-12px-tb-res border-bottom border-color-gray-hint"
                                                    key={id}>
                                                    <span className={`${text_class} e-font-weight-600`}>
                                                        Period
                                                    </span>
                                                    <span className={`${text_class} e-font-weight-600`}>
                                                        Portfolio
                                                    </span>
                                                </div>
                                            }
                                            <div className={`${id !== breakdownData.length - 1 ? "border-bottom" : ""} d-flex align-items-center justify-content-between py-2 padding-12px-tb-res  border-color-gray-hint`}
                                                key={id}>
                                                <span className={text_class}>
                                                    {item.period}
                                                </span>
                                                <span className={text_class}>
                                                    {item.percentage_text}
                                                </span>
                                            </div>
                                        </>
                                        :
                                        <div className="d-flex align-items-center justify-content-between pt-sm-2 padding-12px-tb-res padding-18px-bottom border-bottom border-color-gray-hint"
                                            key={id}>
                                            <div className="d-flex gap-2 align-items-center w-100">
                                                <span className="d-inline-block w-16px h-16 e-border-radius-4 flex-shrink-0"
                                                    style={{ backgroundColor: item.color }}>
                                                </span>
                                                <div className="d-flex column-gap-3 flex-wrap">
                                                    <span className={text_class}>
                                                        {item.type}
                                                    </span>
                                                    <span className={text_class}>
                                                        {item.percentage_text}
                                                    </span>
                                                </div>
                                                <span className={`ms-auto ${text_class}`}>
                                                    {item.amount_text}
                                                </span>
                                            </div>
                                        </div>
                                ))
                            }
                            {
                                type === 2 &&
                                <div className="d-flex align-items-center justify-content-between padding-12px-tb-res"
                                >
                                    <span className={`${text_class} e-font-weight-600`}>
                                        Total
                                    </span>
                                    <span className={`${text_class} e-font-weight-600 ms-auto`}>
                                        ₹{breakdownData && breakdownData.length && breakdownData.reduce((acc, item) => acc + (item.amount || 0), 0).toLocaleString()}
                                    </span>
                                </div>
                            }
                        </div>
                }
            </div>
        )
    };

    const DetailCard = ({ item, type }) => {
        return (
            <>
                <div>
                    <div className="d-flex gap-2 justify-content-between mb-2">
                        <h3 className="e-ellipse e-text-charleston-green e-primary-font-inter e-font-12-res e-font-14 e-font-weight-600 line-height-20px mb-0">
                            {item.fund_name}
                        </h3>
                        <span className="col-auto d-flex gap-1 align-items-center e-ellipse e-text-charleston-green e-primary-font-inter e-font-12-res e-font-14 e-font-weight-600 line-height-20px mb-0">
                            <Icon
                                icon="bullet"
                                color={item.is_purchase ? "#04B488" : "#D65538"}
                                size={"0.25rem"}
                            />
                            {item.is_purchase ? "Purchase" : "Sell"}
                        </span>
                    </div>
                    <div className={`${type === 2 ? "flex-column row-gap-1" : "flex-column flex-md-row justify-content-md-between gap-1"} d-flex `}>
                        <span className={`${type === 2 ? " e-font-12" : "e-font-12-res  e-font-14"} text-wrap e-text-dark-heather e-primary-font-inter e-font-weight-400 line-height-22px`}>
                            Transaction date
                            <span className='text-nowrap ps-1'>
                                {item.transaction_date}
                            </span>
                        </span>
                        <span className={` ${type === 2 ? "e-font-12" : "e-font-12-res  e-font-14 text-md-end"} text-wrap e-text-dark-heather e-primary-font-inter e-font-weight-400 line-height-22px`}>
                            Settlement date
                            <span className='text-nowrap ps-1'>
                                {item.settlement_date}
                            </span>
                        </span>
                    </div>
                </div>
                <div className="d-flex justify-content-between">
                    <div className="col-auto d-flex flex-column">
                        <span className="e-text-dark-heather e-primary-font-inter e-font-12-res  e-font-14 e-font-weight-400 line-height-22px">
                            Quantity
                        </span>
                        <span className="e-text-chinese-black e-primary-font-inter e-font-12-res e-font-14 e-font-weight-400 line-height-22px">
                            {item.quantity_text}
                        </span>
                    </div>
                    <div className="col-auto d-flex flex-column text-end">
                        <span className="e-text-dark-heather e-primary-font-inter e-font-12-res  e-font-14 e-font-weight-400 line-height-22px">
                            Unit Price
                        </span>
                        <span className="e-text-chinese-black e-primary-font-inter e-font-12-res e-font-14 e-font-weight-400 line-height-22px">
                            {item.unit_price_text}
                        </span>
                    </div>
                </div>
                <div className="d-flex flex-wrap justify-content-between">
                    <div className="col-auto d-flex flex-column">
                        <span className="e-text-dark-heather e-primary-font-inter e-font-12-res  e-font-14 e-font-weight-400 line-height-22px">
                            Brkg
                        </span>
                        <span className="e-text-chinese-black e-primary-font-inter e-font-12-res e-font-14 e-font-weight-400 line-height-22px">
                            {item.brokerage_text}
                        </span>
                    </div>
                    <div className="col-auto d-flex flex-column text-end">
                        <span className="e-text-dark-heather e-primary-font-inter e-font-12-res  e-font-14 e-font-weight-400 line-height-22px">
                            STT
                        </span>
                        <span className="e-text-chinese-black e-primary-font-inter e-font-12-res e-font-14 e-font-weight-400 line-height-22px">
                            {item.stt_text}
                        </span>
                    </div>
                </div>
                <div className="d-flex gap-1 flex-nowrap justify-content-between">
                    <div className="col-6 d-flex flex-column">
                        <span className="text-wrap e-text-dark-heather e-primary-font-inter e-font-12-res  e-font-14 e-font-weight-400 line-height-22px">
                            Settlement amount
                        </span>
                        <span className="e-text-chinese-black e-primary-font-inter e-font-12-res e-font-14 e-font-weight-400 line-height-22px">
                            {item.settlement_amount_text}
                        </span>
                    </div>
                </div>
            </>
        )
    };


    return (
        <>
            <div className="row min-h-100vh pb-4 pb-sm-5 align-items-start e-bg-lotion px-4 px-sm-5 ps-lg-4 pe-lg-0  e-border-radius-TL-BL-24px">

                {
                    isDataLoading ? (
                        <div className="min-h-100vh text-center mt-5" >
                            <Loader />
                        </div>)
                        :
                        <div className="col-lg-11 p-0">
                            <div className="row">
                                <div className="col-12">
                                    <PortfolioCard type={2}
                                        wrapperClassName={"my-4"}
                                        title={"Current portfolio value as of 28 Aug 2025"}
                                        summary={portfolioSummary.portfolio}
                                        handleToggleShowValues={_handleToggleShowValues}
                                        showValues={showValues} />
                                </div>
                            </div>
                            <div className="row pt-2 mb-4">
                                <div className="col-4 d-flex justify-content-between">
                                    {
                                        PMS_TAB.map((data) => (
                                            <CustomTab key={data.id}
                                                className="text-center"
                                                type={4}
                                                tabData={data}
                                                tabIndex={tabIndex}
                                                handleChange={_handleTabChange} />
                                        ))
                                    }
                                </div>
                            </div>
                            {
                                tabIndex === 1 ?
                                    <>
                                        <div className="row gx-32px row-gap-4">
                                            <div className="col-12 col-md-6 order-1">
                                                <BreakDownDataCard type={1}
                                                    title={"Portfolio performance"}
                                                    breakdownData={portfolioSummary.performance} />

                                            </div>
                                            <div className="col-12 col-md-6 order-3 order-md-2">
                                                <BreakDownDataCard type={2}
                                                    title={"Portfolio allocation"}
                                                    breakdownData={portfolioSummary.asset_allocation} />
                                            </div>
                                            <div className="col-md-6 order-2 order-md-3">
                                                <p className='fst-italic e-color-black e-font-14-res e-font-16 e-primary-font-inter e-font-weight-400 line-height-28px'>
                                                    *Returns over 1 year period are annualized. Returns are adjusted for inflows/outflows.
                                                </p>
                                            </div>
                                        </div>
                                    </>
                                    :

                                    <div className="row row-gap-4 gx-gy-32px">
                                        <div className={`${isCardView ? "col-12" : "col-md-8"} `}>
                                            <div className="d-flex justify-content-between">
                                                <SectionTitle title="Transactions"
                                                    fontFamily="e-primary-font-inter"
                                                    fontSiz="e-font-20"
                                                    className=" e-text-eerie-black" />
                                                <Icon icon={isCardView ? "list-view" : "card-view"}
                                                    className="cursor-pointer w-24px width-16px-res"
                                                    onClick={_handleChangeOrdersView} />
                                            </div>
                                            <div className={`mt-4 ${isCardView ? "" : "flex-column"} row row-gap-4`}>
                                                {
                                                    portfolioTransactions.length > 0 ?
                                                        portfolioTransactions.map((item, id) => (
                                                            <div className={`${isCardView ? "col-sm-6" : "col-12"}`} key={id}>
                                                                <div className={`${isCardView === false && selectedOrder.fund_name === item.fund_name ? "e-border-1px-egyptian-blue" : "border-transparent"} ${!isCardView ? "cursor-pointer" : "pe-none"} transition h-100 d-flex flex-column gap-2 row-gap-sm-4 row-gap-2 gap-sm-3 p-3 e-bg-cultured e-border-radius-16`}
                                                                    onClick={() => _handleSelectOrderItem(item)}>
                                                                    {
                                                                        isCardView ?
                                                                            <DetailCard item={item} />
                                                                            :
                                                                            <div className="py-2 d-flex justify-content-between">
                                                                                <h3 className="e-ellipse e-text-onyx e-primary-font-inter e-font-14-res e-font-16 e-font-weight-400 line-height-20px mb-0">
                                                                                    {item.fund_name}
                                                                                </h3>
                                                                                <span className={`${item.is_purchase ? "e-text-bottle-green" : "e-text-manhattan-red"} e-text-chinese-black e-primary-font-inter e-font-14-res e-font-16 e-font-weight-700 line-height-22px`}>
                                                                                    {item.is_purchase ? "Purchase" : "Sell"}
                                                                                </span>
                                                                            </div>
                                                                    }
                                                                </div>
                                                            </div>
                                                        ))
                                                        :
                                                        <div className="mt-5 col-6 mx-auto">
                                                            <EmptyScreen img={require("../../Assets/Images/EmptyScreen/no-data.webp")}
                                                                title="No data found"
                                                                type={2}
                                                                description="There is nothing to show right now." />
                                                        </div>

                                                }
                                            </div>
                                        </div>
                                        {/* Right side detail view */}
                                        <div className={`${isCardView ? "d-none" : "col-md-4 d-md-block d-none"}`} id='detailed-pms-fund-view'>
                                            {
                                                selectedOrder.fund_name ?
                                                    <div className="e-border-1px-white-marble e-border-radius-24 p-3 d-flex flex-column gap-2 row-gap-4 gap-sm-3">
                                                        <DetailCard item={selectedOrder} type={2} />
                                                    </div>
                                                    :
                                                    <DetailPreviewCard title={"Pick an Order to get started"}
                                                        description=" Detailed insights will appear here once you choose a order." />
                                            }
                                        </div>
                                    </div>
                            }
                        </div>
                }
            </div>
            <Footer />



            {/* For mobile showing data in offcanvas */}
            {
                selectedOrder?.fund_name &&
                <OffcanvasDetailViewModal title="Transaction Detail">
                    <div className="e-border-1px-white-marble e-border-radius-24 p-3 d-flex flex-column gap-2 row-gap-4 gap-sm-3">
                        <DetailCard item={selectedOrder} type={2} />
                    </div>
                </OffcanvasDetailViewModal>
            }
        </>
    )
}

export default PMS